module.exports = __webpack_public_path__ + "img/load.36cea68c.png";